import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 bg-forest text-white relative overflow-hidden" data-id="element-138">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#E8F0E8 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-139"></div>

      <div className="container mx-auto px-6 max-w-4xl relative z-10" data-id="element-140">
        <FadeIn data-id="element-141">
          <div className="text-center mb-12" data-id="element-142">
            <ShieldCheck className="w-16 h-16 text-gold mx-auto mb-6" data-id="element-143" />
            <h2 className="text-3xl md:text-5xl font-bold mb-6 text-white" data-id="element-144">
              El Secreto es el Bio-Reset de 72 Horas
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-145">
          <div className="bg-white/10 backdrop-blur-md p-8 md:p-12 rounded-3xl border border-white/20 text-center md:text-left" data-id="element-146">
            <p className="text-xl md:text-2xl leading-relaxed font-light mb-6" data-id="element-147">
              A diferencia de las dietas restrictivas, este protocolo utiliza la{' '}
              <strong className="text-gold font-semibold" data-id="element-148">
                Eliminación Selectiva
              </strong>
              .
            </p>
            <p className="text-lg md:text-xl text-mint/90 leading-relaxed mb-6" data-id="element-149">
              Aislamos y retiramos los 4 "Jinetes del Apocalipsis Digestivo"
              durante 3 días estratégicos. Al quitar el combustible del
              incendio, tu cuerpo finalmente puede drenar el líquido retenido y
              apagar la señal de alerta.
            </p>
            <p className="text-2xl font-serif italic text-white" data-id="element-150">
              Es un reinicio biológico, no una dieta de hambre.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}